import API from 'src/api'
import { http } from '../boot/axios'

/**
 * Torre de Control.
 *
 * Los servicios devuelven la promesa de axios tal cual (sin envolverla en
 * `new Promise`). Todos los listados llegan paginados desde el backend: nada de
 * traer el universo y filtrar en el cliente.
 */
export default {
  URL: API.URL,
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,

  // --- Catálogos del panel de filtros -------------------------------------

  fetchUsers (payload) {
    return http.post(`${this.GRAPHQL_URL}fetchUsers`, payload)
  },
  fetchLocations (payload) {
    return http.post(`${this.GRAPHQL_URL}fetchLocations`, payload)
  },
  fetchOrganizationLocations (params) {
    return http.get(`${this.GRAPHQL_URL}fetchOrganizationLocations`, { params })
  },
  fetchAreas (params) {
    return http.get(`${this.GRAPHQL_URL}fetchAreas`, { params })
  },
  fetchCategories () {
    return http.get(`${this.GRAPHQL_URL}fetchCategories`)
  },

  // --- Tablero -------------------------------------------------------------

  fetchBoard (payload) {
    return http.post(`${this.GRAPHQL_URL}controlTower/board`, payload)
  },
  fetchColumnTasks (payload) {
    return http.post(`${this.GRAPHQL_URL}controlTower/board/column`, payload)
  },
  fetchTaskList (payload) {
    return http.post(`${this.GRAPHQL_URL}controlTower/tasks`, payload)
  },
  fetchTaskDetail (id) {
    return http.get(`${this.GRAPHQL_URL}controlTower/tasks/${id}`)
  },
  createTask (payload) {
    return http.post(`${this.GRAPHQL_URL}controlTower/tasks/create`, payload)
  },

  // --- Indicadores del dashboard y su detalle ------------------------------

  /**
   * El orden de los argumentos estaba cruzado entre este servicio, la acción
   * del store y la página: la URL se armaba con `categorie` recibiendo la fecha
   * de inicio y `startDateOp` recibiendo la categoría. Ahora recibe un objeto,
   * que es inmune a ese error.
   */
  fetchDashboard ({ startDate = null, endDate = null, locations = [], categorie = null, area = null } = {}) {
    const params = {}
    if (locations && locations.length) params.locations = locations.join(',')
    if (categorie) params.categorie = categorie
    if (area) params.area = area
    if (endDate) params.endDateOp = endDate

    const path = startDate
      ? `${this.GRAPHQL_URL}fetchDashboard/${startDate}`
      : `${this.GRAPHQL_URL}fetchDashboard`

    return http.get(path, { params })
  },

  fetchDashboardTasks ({
    startDate = null, endDate = null, locations = [], categorie = null, area = null,
    bucket = 'total', page = 1, perPage = 25
  } = {}) {
    const params = { bucket, page, perPage }
    if (locations && locations.length) params.locations = locations.join(',')
    if (categorie) params.categorie = categorie
    if (area) params.area = area
    if (endDate) params.endDateOp = endDate

    const path = startDate
      ? `${this.GRAPHQL_URL}fetchDashboardTasks/${startDate}`
      : `${this.GRAPHQL_URL}fetchDashboardTasks`

    return http.get(path, { params })
  },

  // --- Acciones masivas ----------------------------------------------------

  bulkDelete (payload) {
    return http.post(`${this.GRAPHQL_URL}controlTower/tasks/bulk-delete`, payload)
  },
  bulkReassign (payload) {
    return http.post(`${this.GRAPHQL_URL}controlTower/tasks/bulk-reassign`, payload)
  },
  bulkUpdate (payload) {
    return http.post(`${this.GRAPHQL_URL}controlTower/tasks/bulk-update`, payload)
  },

  // --- Mis Filtros y preferencias de columnas ------------------------------

  fetchFilters (params) {
    return http.get(`${this.GRAPHQL_URL}controlTower/filters`, { params })
  },
  saveFilter (payload) {
    return http.post(`${this.GRAPHQL_URL}controlTower/filters`, payload)
  },
  updateFilter (id, payload) {
    return http.put(`${this.GRAPHQL_URL}controlTower/filters/${id}`, payload)
  },
  deleteFilter (id) {
    return http.delete(`${this.GRAPHQL_URL}controlTower/filters/${id}`)
  },
  fetchPreferences (params) {
    return http.get(`${this.GRAPHQL_URL}controlTower/preferences`, { params })
  },
  savePreferences (payload) {
    return http.put(`${this.GRAPHQL_URL}controlTower/preferences`, payload)
  }
}
